export default __webpack_public_path__ + "static/media/video.3287bc3d.svg";